// extracted by mini-css-extract-plugin
export default {"header":"Header_header__k8QYu","menu":"Header_menu__89LWD","link":"Header_link__Iy0lO","active":"Header_active__oAA-r","lang_block":"Header_lang_block__eifgb"};